import React from 'react';
import { IIconProps } from './utils';

export const Download = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 12 12" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M5.99935 1V6.33333M5.99935 6.33333L7.66602 4.66667M5.99935 6.33333L4.33268 4.66667M11.3327 5V7C11.3327 8.10457 10.4373 9 9.33268 9H2.66602C1.56145 9 0.666016 8.10457 0.666016 7V5"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
